export const InventoryChecksList = () => {
  return <div></div>;
};
